import { render, staticRenderFns } from "./PuzzleCell.vue?vue&type=template&id=3f96f5b3"
import script from "./PuzzleCell.vue?vue&type=script&lang=js"
export * from "./PuzzleCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports